import { i18n } from '@/common/i18n'
import { apiService } from '@/common/services/api'

import {
  CreateHelpSystemRequirementApiParams,
  ShowIpApiResult,
  ShowServicesStatusApiResult,
  ShowSystemRequirementApiResult
} from './contracts/api'
import {
  CreateHelpSystemRequirementServiceParams,
  ShowIpServiceResult,
  ShowServiceStatusServiceResult,
  ShowSystemRequirementServiceResult
} from './contracts/services'

export async function showSystemRequirementService(): Promise<ShowSystemRequirementServiceResult> {
  const { data } = await apiService<null, ShowSystemRequirementApiResult>({
    resource: i18n().modules.requirements.resources.showSystemRequirements,
    method: 'get',
    url: '/products_requirements.json',
    baseURL: import.meta.env.VITE_REQUIREMENTS_API_URL
  })
  return data
}

export async function createHelpSystemRequirementService(
  params: CreateHelpSystemRequirementServiceParams
): Promise<null> {
  const { data } = await apiService<CreateHelpSystemRequirementApiParams, null>({
    resource: i18n().modules.requirements.resources.createHelp,
    method: 'post',
    url: '/mail/v1/requirements-checker',
    body: params,
    baseURL: import.meta.env.VITE_HUB_API_URL
  })
  return data
}

export async function showServicesStatusService(): Promise<ShowServiceStatusServiceResult> {
  const { data } = await apiService<null, ShowServicesStatusApiResult>({
    resource: i18n().modules.requirements.resources.showSystemStatus,
    method: 'get',
    url: `/admin/v1/status`,
    baseURL: import.meta.env.VITE_HUB_API_URL
  })
  return data
}

export async function showIpService(): Promise<ShowIpServiceResult> {
  const { data } = await apiService<null, ShowIpApiResult>({
    resource: i18n().modules.requirements.resources.showIp,
    method: 'get',
    url: import.meta.env.VITE_API_URL_IP
  })
  return data
}
